export const ADMIN = "ADMIN";
export const APPNAME = "GWUI";
export const COMPANYCODE = "GW";
export const SOURCE = "UI";
export const PACKAGETYPECUSTOMIZED = "customized";
export const PACKAGETYPEFIXED = "fixed";
export const UPLOADIMAGES = "UploadImages";
export const NextYearsDDL = 5;
export const cultureFormat = "en-IN";

